export const STICKY_HEADER_HEIGHT = 70;
export const HEADER_HIDE_ZONE = 370;
